// extracted by mini-css-extract-plugin
export default {"error-boundary":"KAuscI","errorBoundary":"KAuscI","antena":"RUaiZe","content":"wyHsM0"};